// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab9078b0","455":"9675cb8d","977":"e4c03697"}[chunkId] + ".chunk.js";
};